import { Instance } from 'tippy.js'
import { NegotiationDetail, NegotiationStatus } from 'api'
import { ValidationCellRenderer, ValidationCellRendererParams } from 'view/components/datagrid'
import { RowDataGetter } from 'view/shared/datagrid'
import { ModificationType, isFirstEnteredRate, getIsFirstEnteredHaircutAndHaircutType } from '../shared/deltaGetters'
import { getNegotiationModificationColor } from '../shared/utils'
import './NegotiableCellRenderer.css'
import { CORE_PRIMARY_6 } from 'view/styles/constants'

type NegotiableCellRendererItemProps = Pick<NegotiationDetail, 'ownOrder' | 'negotiation'>

export interface NegotiableCellRendererParams<T extends NegotiableCellRendererItemProps = NegotiableCellRendererItemProps>
  extends ValidationCellRendererParams {
  getModificationType: (negotiationDetail: T) => ModificationType | null
  isRateField: boolean
  isHaircutOrHaircutTypeField: boolean
  rowDataGetter?: RowDataGetter<T>
  dataTestId?: string
}

export class NegotiableCellRenderer extends ValidationCellRenderer {
  protected refreshCell(element: HTMLElement, tooltip: Instance, params: NegotiableCellRendererParams) {
    element.classList.toggle('negotiable-cell', true)
    super.refreshCell(element, tooltip, params)
    this.refreshModificationStyle(element, params)
  }

  private refreshModificationStyle(element: HTMLElement, params: NegotiableCellRendererParams) {
    const negotiationDetail = params.rowDataGetter ? params.rowDataGetter(params, true) : params.node.data
    const modificationColor = getNegotiationModificationColor(params.getModificationType, negotiationDetail)
    const isFirstRateValue = params.isRateField ? isFirstEnteredRate(negotiationDetail) : false
    const isFirstHaircutValue = params.isHaircutOrHaircutTypeField ? getIsFirstEnteredHaircutAndHaircutType(negotiationDetail) : false
    const isModified = !!modificationColor
    const isTargetRate =
      !!params.isRateField &&
      !!negotiationDetail &&
      negotiationDetail.negotiation.status === NegotiationStatus.REQUESTED_WITHOUT_PRICE &&
      !isModified

    element.style.color = isFirstRateValue || isFirstHaircutValue ? CORE_PRIMARY_6 : ''
    element.style.fontWeight = isFirstRateValue || isFirstHaircutValue ? 'bold' : ''
    element.classList.toggle('modified', isModified)
    element.classList.toggle('target-rate', isTargetRate)
    element.style.borderBottomColor = modificationColor || ''
  }
}
